import { config } from './config';
import axios from 'axios';

const api = axios.create({
  baseURL: `https://${config.domain}`,
});

export default api;
